export default "__VITE_PUBLIC_ASSET__34eb4ddb__"